import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import About from "./About/About";
import Dvsim from "./Dvsim/Dvsim";
import Educational from "./Facultets/Educational";
import Industrial from "./Facultets/Industrial";
import Magistr from "./Facultets/Magistr";
import Home from "./Home/Home";
import "./main.css";
import Academic from "./Rektorat/Academic";
import Hope from "./Rektorat/Hope";
import Innovation from "./Rektorat/Innovation";
import InterContact from "./Rektorat/InterContact";
import InterPartners from "./Rektorat/InterPartners";
import Kofedra from "./Rektorat/Kofedra";
import NationalActive from "./Rektorat/NationalActive";
import Rektorat from "./Rektorat/Rektorat";
import SocialActive from "./Rektorat/SocialActive";
import TypeMed from "./Rektorat/TypeMed";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import Pharmacy from "./Facultets/Pharmacy";
import Retraining from "./Facultets/Retraining";
function App() {
  React.useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  
  return (
    <div>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/dvsim" element={<Dvsim />} />
          <Route path="/rektorat" element={<Rektorat />} />
          <Route path="/kofedra" element={<Kofedra />} />
          <Route path="/typemed/:id" element={<TypeMed />} />
          <Route path="/academic" element={<Academic />} />
          <Route path="/innovation" element={<Innovation />} />
          <Route path="/nationalactive" element={<NationalActive />} />
          <Route path="/intercontact" element={<InterContact />} />
          <Route path="/interpartners" element={<InterPartners />} />
          <Route path="/hope" element={<Hope />} />
          <Route path="/socialactive" element={<SocialActive />} />
          <Route path="/educational" element={<Educational />} />
          <Route path="/industrial" element={<Industrial />} />
          <Route path="/magistr" element={<Magistr />} />
          <Route path="/pharmacy" element={<Pharmacy />} />
          <Route path="/retraining" element={<Retraining />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
